/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, Fragment, useState, useLayoutEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CircularProgressbar } from 'react-circular-progressbar';
import { allClassesDetails } from '../Store/api/professor/dashboard';
import 'react-circular-progressbar/dist/styles.css';

import arrowRight from '../assets/images/arrow-right.png';
import Navbar from '../components/dashboard/Navbar';

import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../components/dashboard/Sidebar';
import book from '../assets/images/classs-img.png';
import Calendar from '../components/dashboard/Calendar';
import storage from '../services/storage';
import { ActivityLoadingSkeleton } from '../shared/ActivityLoadingSkeleton';

const Dashboard = () => {
  const navigate = useNavigate();
  const Storeuser = storage.get('user');
  const [allClasses, setAllClasses] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  /* This code for Circular progrss bar of Student activity */
  const [progrssBar, setProgrssBar] = useState(72);
  const [gotoSubject, setGotoSubject] = useState(1);
  const [totalActivities, setTotalActivities] = useState(0);
  const [activitiesGraded, setActivitiesGraded] = useState(0);
  const [activtiesPastDue, setActivitiesPastDue] = useState(0);
  const [pastActivties, setPastActivities] = useState(0);
  const [submitted, setSubmitted] = useState(0);
  const [activitiesSubmitted, setActivitiesSubmitted] = useState(0);
  const [avgPercentage, setAvgPercentage] = useState(0);
  const classesSections = useSelector((state) => state.entities.classes);
  const user = storage.get('user');
  const lastBookId = storage.get('lastBookId');
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (Storeuser.status === 'denied') navigate('/access-denied', { replace: true });
  }, [Storeuser.status]);

  useEffect(() => {
    dispatch(
      allClassesDetails({
        onSuccess: (res) => {
          const data = res.data.data || [];
          setAllClasses(data);

          setTotalActivities(data.reduce((total, item) => total + item.allActivityAnswers.length, 0));
          const gradedAns = res.data.data.flatMap((cla) => cla.allActivityAnswers.filter((ans) => ans.isGraded));

          setAvgPercentage(gradedAns?.length > 1 ? gradedAns.reduce((acc, next) => acc + next.grade, 0) / gradedAns.length : 0);

          // Count graded activities safely
          setActivitiesGraded(data.reduce((acc, item) => acc + item.allActivityAnswers.filter((e) => e.isGraded).length, 0));

          // Count submitted activities safely
          setActivitiesSubmitted(
            data.reduce((acc, item) => {
              const submittedActivities = item.allActivityAnswers.filter((e) => e.answers.length > 0).length; // Ensure at least one answer exists

              return acc + submittedActivities;
            }, 0)
          );

          // Count past-due activities safely
          const allFlattenedActivities = res.data.data.flatMap((classData) => classData.allActivities || []);

          setActivitiesPastDue(
            data.reduce((count, classData) => {
              return (
                count +
                (classData.allActivities || []).filter((e) => {
                  new Date(e.assignedDate) < new Date() && e.activityAnswers?.some((answerObj) => answerObj?.answers?.length && !answerObj.isGraded); // At least one ungraded answer
                }).length
              );
            }, 0)
          );

          const pastDueActivities = data
            .flatMap((assignAct) =>
              assignAct.allActivities.map((activity) => ({
                ...activity,
                parent: assignAct,
              }))
            )
            .filter((activity) => {
              if (!activity.assignedDate) return false; // Skip activities without assignedDate

              const assignedDate = new Date(activity.assignedDate);
              const currentDate = new Date();
              const isPastDue = assignedDate < currentDate; // Check if it's past due

              const hasNoAnswers =
                activity.activityAnswers && // Ensure activityAnswers exists
                activity.activityAnswers.some((answerObj) => answerObj.answers && !answerObj.isGraded); // Ensure all answers are empty

              return isPastDue && hasNoAnswers;
            })
            .map((activity) => activity.parent); // Return the original `assignAct` objects
          setPastActivities(pastDueActivities);

          setIsloading(false);
        },
        onError: (error) => {
          setIsloading(false);
          console.error(error);
        },
      })
    );
  }, []);

  useEffect(() => {
    if (!lastBookId) {
      storage.store('lastBookId', user.isBookOpened);
    }
  }, [lastBookId, user]);

  return (
    <Fragment>
      <div className='wrapper'>
        {/* <!-- Page Sidebar --> */}
        <Sidebar userType='teacher' sideBarEvent={'overview'} setGotoSubject={setGotoSubject} />
        {/* <!-- Page Content Holder --> */}
        <div id='content'>
          <div className='content_dashborad_inner'>
            {/* <!-- navbar --> */}

            <Navbar />

            <div className='main_section_content'>
              <div className='center_content center_content_h90vh'>
                <ActivitythisWeek isLoading={isLoading} progrssBar={avgPercentage} activitiesGraded={activitiesGraded} activitiesSubmitted={activitiesSubmitted} totalActivities={totalActivities} activtiesPastDue={activtiesPastDue} setSubmitted={setSubmitted} submitted={submitted} pastActivties={pastActivties} />

                <ActivitesDueNext classes={allClasses} loading={isLoading} totalActivities={totalActivities} submitted={submitted} pastActivties={pastActivties} />
              </div>
              <div className='right_content right_content_main_overview bg_white'>
                <Calendar activities={[...new Map(allClasses.flatMap((clas) => clas.allActivities).map((obj) => [obj['_id'], obj])).values()]} allClasses={allClasses} />
                <div
                  className='mt_32'
                  style={{
                    width: '382px',
                    display: 'flex',
                    padding: '12px 16px',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    borderRadius: '4px',
                    background: 'white !important',
                    border: '1px solid #F0F0EF',
                    boxShadow: '0px 0px 12px 0px rgba(0, 0, 0, 0.08)',
                  }}
                >
                  <AssignActivityRightside classes={allClasses} classesSections={classesSections} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );

  function ActivitythisWeek({ progrssBar, activitiesGraded, activitiesSubmitted, totalActivities, activtiesPastDue, pastActivties, setSubmitted, submitted }) {
    const [total, setTotal] = useState(0);
    const [remaining, setRemaining] = useState(0);

    useEffect(() => {
      const intervals = [];

      function createInterval(setState, targetValue) {
        const intervalId = setInterval(() => {
          setState((prev) => {
            if (prev >= targetValue) {
              clearInterval(intervalId);
              return targetValue;
            }
            return prev + 1;
          });
        }, 1000 / targetValue);

        intervals.push(intervalId);
      }

      createInterval(setTotal, totalActivities);
      createInterval(setSubmitted, activitiesSubmitted);
      createInterval(setRemaining, activtiesPastDue);

      return () => {
        intervals.forEach(clearInterval);
      };
    }, [activitiesSubmitted, totalActivities, activtiesPastDue]);

    return (
      <div className='box_border activities_wrap border_shadow'>
        <div className='activities_wrap_inner'>
          <div className='activities_completed d-flex flex-column align-items-center'>
            {isLoading ? (
              <h4 className='content-skeleton m-0'></h4>
            ) : (
              <div className='fancy_text'>
                <p className='p1'>{submitted}</p>
                <p className='p2'>/</p>
                <p className='p3'>{total}</p>
              </div>
            )}
            <h5 className='ft_14 mt_16 fw_400'>activities submitted</h5>
          </div>
          <div className='graph_wrap d-flex flex-column align-items-center'>
            {isLoading ? (
              <h4 className='content-skeleton m-0'></h4>
            ) : (
              <div className='progress-bar-outer' style={{ position: 'relative' }}>
                <span className='helloss' data-title='This week - 10'>
                  <MyCircularProgressBar progrssBar={progrssBar} />
                </span>
              </div>
            )}
            <h5 className='ft_14 fw_400 mt_16'>Activities graded</h5>
          </div>
          <div className='cumulative_wrap d-flex flex-column align-items-center'>
            {isLoading ? <h4 className='content-skeleton m-0'></h4> : <div className='fancy_text'>{pastActivties.length}</div>}
            <h5 className='ft_14 mt_16 fw_400'>Activities Past Due</h5>
          </div>
        </div>
      </div>
    );
  }
  function ActivitesDueNext({ classes, totalActivities, submitted, pastActivties, loading }) {
    const [isExapnded, setIsExpanded] = useState(false);
    const currentDate = new Date();
    let dateAfterSeven = new Date(currentDate);
    dateAfterSeven.setDate(currentDate.getDate() + 7);
    const transformedArray = classes.map((item) => {
      const { courseName, courseNumber, _id, allActivityAnswers, numberOfStudents, allActivities } = item;
      // const submitted =
      //   allActivityAnswers && Array.isArray(allActivityAnswers)
      //     ? allActivityAnswers.filter((e) => e.answers.length).length
      //     : 0;

      const unGradedAnswers = allActivityAnswers ? allActivityAnswers.filter((ans) => !ans.isGraded && ans.answers.length) : [];

      const flatAnswers = unGradedAnswers.map((answer) => ({
        ...answer,
        courseName,
        courseNumber,
        classId: _id,
        submitted,
        totalActivities,
      }));

      return flatAnswers;
    });

    let activityAnswers = [].concat(...transformedArray);
    activityAnswers = activityAnswers.filter((obj, index, self) => self.findIndex((o) => o.activity._id === obj.activity._id) === index);
    activityAnswers.sort((a, b) => new Date(a.activity.assignedDate) - new Date(b.activity.assignedDate));

    return (
      <div className='activities_due_next_over box_border mt_32' style={{ padding: '4px 0px', border: 'none', boxShadow: 'none' }}>
        <div className='head_dash'>
          <h5 className='ft_24'>activities ready for grading</h5>
          <p className='ft_12'>{classes.reduce((acc, next) => acc + (next.allActivityAnswers ? next.allActivityAnswers.filter((e) => new Date(e.activity.assignedDate) > currentDate && new Date(e.activity.assignedDate) < dateAfterSeven && e.answers.length > 0 && !e.isGraded).length : 0), 0)} activities due in next 7 days</p>
        </div>

        {loading
          ? [...new Array(4)].map((item) => <ActivityLoadingSkeleton key={item} />)
          : activityAnswers
              .filter((e) => e.answers.length)
              .slice(0, isExapnded ? activityAnswers.length : 5)
              .map((answer, index) => (
                <div className='Definition_of_terms' key={index}>
                  <div className='img_Wrap_book'>
                    <img src={answer.activity.book?.coverImage || answer.activity.book?.activityBookCoverUrl || book} alt='BookCover' />
                  </div>
                  <div className='text_right'>
                    <div className='book_text font_inter' style={{ width: '41%' }}>
                      <h6 className='ft_12 fw-700 '>
                        {answer.courseName} {answer.courseNumber}
                      </h6>
                      <h5 className='ft_12 fw-500 mt_10'>
                        <u>chapter {answer.activity.chapter?.order}</u>
                      </h5>
                      <h1 className='ft_18 fw-700 mt_10 mb-0'>{answer?.activity?.title}</h1>
                    </div>
                    <div className='book_text text-end font_inter'>
                      <div className='d-flex align-items-center justify-content-end'>
                        <h6
                          className='ft_12 fw-700 mb-0'
                          style={{
                            color: `${new Date(answer.activity.assignedDate) < currentDate ? '#AE2604' : 'black'}`,
                          }}
                        >
                          {new Date(answer.activity.assignedDate) < currentDate ? 'Past due date' : 'Due date'}
                        </h6>
                        {new Date(answer.activity.assignedDate) > currentDate && (
                          <p className='mb-0 fw-400 ft_12' style={{ marginLeft: '5px' }}>
                            {answer.activity.assignedDate.split('T')[0]}
                          </p>
                        )}
                      </div>
                      <h5 className='ft_12 fw-400 mt_10 mb-16'>
                        <b>
                          {submitted}/{totalActivities}
                        </b>{' '}
                        submitted
                      </h5>
                      <h5 className='ft_12 fw-500  mb-0'>
                        <Link to={`/dashboard/gradding/${answer?.activity._id}/${answer?.classId}`} className='ft_12 fw-500'>
                          <u>START</u>
                        </Link>
                        <Link to={`/dashboard/gradding/${answer?.activity._id}/${answer?.classId}`} className='ft_12 fw-500'>
                          details
                          <img src={arrowRight} alt='arrow-right' />
                        </Link>
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
        {activityAnswers.length > 5 && (
          <div className='ft_12 fw-500 mt_10 d-flex justify-content-between'>
            {!isExapnded ? <p>+ {activityAnswers.length - 5} activities</p> : <p></p>}
            <a
              className='ft_12 fw-500 cursor'
              onClick={() => {
                setIsExpanded((old) => !old);
              }}
            >
              <u>
                view {isExapnded ? 'less' : 'all'} activities
                <img src={arrowRight} alt='arrow-right' />
              </u>
            </a>
          </div>
        )}
      </div>
    );
  }

  function AssignActivityRightside({ classes, classesSections }) {
    const currentDate = new Date();
    let dateAfterSeven = new Date(currentDate);
    dateAfterSeven.setDate(currentDate.getDate() + 7);

    return (
      <Fragment>
        {classes.map((clas, index) => {
          let allActivitiesAnswers = clas.allActivities.flatMap((act) => act.activityAnswers);

          let gradedPercentage = Math.round(
            allActivitiesAnswers?.filter((x) => x.isGraded).reduce((acc, next) => acc + (next.answers?.length ? next.answers.reduce((a, b) => a + (b.grade ?? 0), 0) : 0), 0) / (allActivitiesAnswers?.length || 1) // Prevent division by zero
          );

          // Ensure it's not NaN
          gradedPercentage = isNaN(gradedPercentage) ? 0 : gradedPercentage;

          return (
            <div
              className='box_border date_Schedule'
              style={{
                width: '100%',
                padding: '0px',
                borderRadius: '0px',
                border: 'none',
                boxShadow: 'none',
              }}
              key={clas._id}
            >
              {classes.length > 1 && index !== 0 && <div className='bottom-line'></div>}
              <Fragment>
                <h1 className='ft_16 mb-0'>
                  {clas.courseName}
                  <Link to={`/dashboard/classes/${clas._id}`}>
                    <img src='/assets/images/arrow-right.png' width={18} height={10} alt='arrow' />
                  </Link>
                </h1>
                <div className='class-sesction mb-0 mt-1'>{clas?.numberOfSections ?? 0 === 1 ? `${clas?.numberOfSections ?? 0} section` : `${clas?.numberOfSections ?? 0} section${(clas?.numberOfSections ?? 0) === 0 ? '' : 's'}`}</div>
                <div className='mt-2 d-flex font_inter'>
                  <h1 className='ft_14 fw-600 txt_cap w-135px mb-0 align-center'>Cuml. Grade</h1>
                  <div className='grade_indicator'>
                    <p
                      className='mb-0'
                      style={{
                        textAlign: 'end',
                        paddingRight: '5px',
                        width: `${gradedPercentage > 0 ? gradedPercentage : 'default'}%`,
                        background: `${gradedPercentage >= 50 ? '#CDE5E1' : gradedPercentage === 0 ? '#ffff' : '#f5c8c8'}`,
                      }}
                    >
                      {gradedPercentage === 0 ? '--' : gradedPercentage}%
                    </p>
                  </div>
                </div>
                <div className='d-flex font_inter mt-2'>
                  <h1 className='ft_14 fw-600 txt_cap w-135px align-center mb-0'>Activities</h1>
                  <div className='ft_14 fw-400 txt_smal'>
                    <b>{clas.allActivityAnswers?.filter((e) => e.isGraded).length || 0}</b>/{clas.allActivityAnswers?.length || 0} Completed
                  </div>
                </div>
                <div className='d-flex font_inter mt-2'>
                  <h1 className='ft_14 fw-600 text-white txt_cap mb-0 w-135px'>Activities</h1>
                  <div className='ft_14 fw-400 txt_smal mb-0'>
                    <b>{clas.allActivityAnswers?.filter((e) => new Date(e.activity.assignedDate) > currentDate && new Date(e.activity.assignedDate) < dateAfterSeven && e.answers.length > 0 && !e.isGraded).length || 0}</b> due in next 7 days
                  </div>
                </div>
                <div className='d-flex font_inter mt-2'>
                  <h1 className='ft_14 fw-600 text-white txt_cap mb-0 w-135px'></h1>
                  <div className='ft_14 fw-400 txt_smal mb-0'>
                    <b>{clas.allActivityAnswers?.filter((e) => e.answers?.length > 0).length || 0}</b>/{clas.allActivityAnswers?.length || 0} submitted
                  </div>
                </div>
              </Fragment>
            </div>
          );
        })}
      </Fragment>
    );
  }
};

function MyCircularProgressBar({ progrssBar }) {
  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);

  useEffect(() => {
    setValue1(progrssBar);
  }, [progrssBar]);

  useEffect(() => {
    const id = setInterval(inc, progrssBar > 0 ? 1000 / progrssBar : 1);

    function inc() {
      setValue((prev) => {
        if (prev >= progrssBar) {
          clearInterval(id);
          return prev;
        }
        return prev + 1;
      });
    }
  }, [progrssBar]);

  return (
    <CircularProgressbar
      className='prof'
      value={value1}
      text={value + '%'}
      styles={{
        root: {},
        path: {
          stroke: `rgba(103, 0, 178, 1), ${value1 > 0 ? value1 / 100 : 0})`,
          transition: 'stroke-dashoffset 0.5s ease 0s',
          transform: 'rotate(25turn)',
          transformOrigin: 'center center',
        },
        trail: {
          stroke: 'rgba(221, 213, 235, 1)',
          strokeLinecap: 'butt',
          transform: 'rotate(25turn)',
          transformOrigin: 'center center',
        },
        text: {
          fill: '#2E2E2D',
          fontFamily: 'Nixie One',
          fontSize: '25px',
          fontStyle: 'normal',
          fontWeight: 600,
          lineHeight: '125%' /* 50px */,
          letterSpacing: '2px',
        },
        background: {
          fill: '#3e98c7',
        },
      }}
    ></CircularProgressbar>
  );
}

export default Dashboard;
